import React, { useEffect, useState } from 'react';
import { Button } from './ui/Button';
import { Menu, X, Mail, Phone } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Solutions',
    href: '#solutions'
  }, {
    name: 'How It Works',
    href: '#how-it-works'
  }, {
    name: 'Pricing',
    href: '#pricing'
  }, {
    name: 'Case Studies',
    href: '#results'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  const handleGetStarted = () => {
    const ctaSection = document.getElementById('contact');
    if (ctaSection) {
      ctaSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ease-out ${isScrolled ? 'bg-white/95 backdrop-blur-md border-b border-gray-200 shadow-sm pt-3 pb-0' : 'bg-white pt-4 pb-1'}`} data-id="element-274">
      <div className="container mx-auto px-4 md:px-6 flex items-center justify-between" data-id="element-275">
        {/* Logo */}
        <a href="#" className="block" onClick={e => {
        e.preventDefault();
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }} data-id="element-276">
          <img src="https://cdn.magicpatterns.com/uploads/deMtZXKBURihBiL6WqNEBc/Strattigize_(3)_(3).png" alt="Strattigize Logo" className="h-16 md:h-20 w-auto transition-all duration-500 ease-out hover:scale-[1.02] hover:-translate-y-0.5" style={{
          imageRendering: 'auto',
          WebkitFontSmoothing: 'antialiased',
          transform: 'translateY(-1px)',
          filter: ['drop-shadow(0px 2px 3px rgba(0,0,0,0.18))', 'drop-shadow(0px 4px 8px rgba(0,0,0,0.12))', 'drop-shadow(0px 8px 16px rgba(0,0,0,0.08))', 'drop-shadow(0px 1px 0px rgba(232,76,26,0.1))'].join(' ')
        }} loading="eager" decoding="async" data-id="element-277" />
        </a>

        {/* Desktop Menu */}
        <div className="hidden md:flex items-center space-x-8" data-id="element-278">
          {navLinks.map(link => <a key={link.name} href={link.href} className="relative text-sm font-medium text-black hover:text-gray-600 transition-colors duration-300 group" onClick={e => {
          e.preventDefault();
          const element = document.querySelector(link.href);
          if (element) {
            element.scrollIntoView({
              behavior: 'smooth'
            });
          }
        }} data-id="element-279">
              {link.name}
              <span className="absolute left-0 bottom-[-4px] w-0 h-[2px] bg-primary transition-all duration-500 ease-out group-hover:w-full" data-id="element-280" />
            </a>)}
          <a href="tel:+447366433459" className="flex items-center space-x-1.5 text-sm font-medium text-primary hover:text-primary-dark transition-colors duration-300" data-id="element-281">
            <Phone size={16} data-id="element-282" />
            <span className="hidden lg:inline" data-id="element-283">+44 7366 433459</span>
          </a>
          <a href="mailto:strattigize@gmail.com" className="flex items-center space-x-1.5 text-sm font-medium text-primary hover:text-primary-dark transition-colors duration-300" data-id="element-284">
            <Mail size={16} data-id="element-285" />
            <span className="hidden lg:inline" data-id="element-286">strattigize@gmail.com</span>
          </a>
          <Button size="sm" className="ml-2" onClick={handleGetStarted} data-id="element-287">
            GET STARTED
          </Button>
        </div>

        {/* Mobile Menu Button */}
        <button className="md:hidden text-black transition-transform duration-300" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-288">
          {isMobileMenuOpen ? <X data-id="element-289" /> : <Menu data-id="element-290" />}
        </button>
      </div>

      {/* Mobile Menu Overlay */}
      <AnimatePresence data-id="element-291">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} className="md:hidden bg-white border-b border-gray-200 overflow-hidden" data-id="element-292">
            <div className="flex flex-col p-4 pb-2 space-y-4" data-id="element-293">
              {navLinks.map(link => <a key={link.name} href={link.href} className="text-black font-medium hover:text-primary transition-colors duration-300" onClick={e => {
            e.preventDefault();
            setIsMobileMenuOpen(false);
            const element = document.querySelector(link.href);
            if (element) {
              element.scrollIntoView({
                behavior: 'smooth'
              });
            }
          }} data-id="element-294">
                  {link.name}
                </a>)}
              <a href="tel:+447366433459" className="flex items-center space-x-2 text-primary font-medium" data-id="element-295">
                <Phone size={16} data-id="element-296" />
                <span data-id="element-297">+44 7366 433459</span>
              </a>
              <a href="mailto:strattigize@gmail.com" className="flex items-center space-x-2 text-primary font-medium" data-id="element-298">
                <Mail size={16} data-id="element-299" />
                <span data-id="element-300">strattigize@gmail.com</span>
              </a>
              <Button fullWidth onClick={() => {
            setIsMobileMenuOpen(false);
            handleGetStarted();
          }} data-id="element-301">
                GET STARTED
              </Button>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}